
import { defineComponent, ref, onBeforeMount } from 'vue-demi'
import { c4bApi } from '@/api/C4bApi'
import { useRoute } from 'vue-router'
import { currencyFormatBR } from '@/use/numberFormatBR'
import CheckboxInput from '@/components/ui/CheckboxInput.vue'
import ButtonDefault from '@/components/ui/ButtonDefault.vue'
import SuccessForm from '@/components/common/TheSuccessForm.vue'
import { EValidity, checkErrorsReturn, capitalize } from '@/use/validInput'
import IContract from '@/types/contract'
import { ContractConfiguration } from '@/config/variables'

export default defineComponent({
    components: {
        CheckboxInput,
        ButtonDefault,
        SuccessForm,
    },
    setup() {
        const pdfString = ref('')
        const credit = ref(0)
        const installments = ref('')
        const bank = ref('')
        const branch = ref('')
        const account = ref('')
        const pageReady = ref(false)
        const wasContractSigned = ref(false)
        const route = useRoute()
        const contractData = ref({
            customerID: 1,
            ContractPdf: pdfString,
            acceptTerms: false,
            authorizeSCR: false,
            existsPEP: false,
        })
        const messageResponse = ref({})
        const hash = route.params.id as string
        const checkboxValidationStatus = ref({
            acceptTerms: EValidity.Undefined,
            authorizeSCR: EValidity.Undefined,
            existsPEP: EValidity.Undefined,
        })
        const generateContract = async () => {
            try {
                const contractInfo = await c4bApi.contract().get(hash)
                pdfString.value = contractInfo.data.contractPdf
            } catch (err: any) {
                window.location.href = '/Error'
            }
        }
        const getCustomerInfo = async () => {
            try {
                const customerInfo = await c4bApi.user().get(hash)
                credit.value = Number(customerInfo.data.limit)
                installments.value = customerInfo.data.installment
            } catch (err: any) {
                window.location.href = '/Error'
            }
        }
        const getBankInfo = async () => {
            try {
                const bankInfo = await c4bApi.bankInfo().get(hash)
                bank.value = bankInfo.data.bankName
                branch.value = bankInfo.data.branch
                account.value = bankInfo.data.checkingAccount
                contractData.value.customerID = bankInfo.data.customerID
            } catch (err: any) {
                window.location.href = '/Error'
            }
        }
        const validFrontSign = (sign: IContract) => {
            const newStatus = { ...checkboxValidationStatus.value }
            if (sign.acceptTerms == false)
                newStatus.acceptTerms = EValidity.Invalid
            else newStatus.acceptTerms = EValidity.Valid
            if (sign.authorizeSCR == false)
                newStatus.authorizeSCR = EValidity.Invalid
            else newStatus.authorizeSCR = EValidity.Valid
            if (sign.existsPEP == false) newStatus.existsPEP = EValidity.Invalid
            else newStatus.existsPEP = EValidity.Valid
            checkboxValidationStatus.value = newStatus
            if (
                checkboxValidationStatus.value.acceptTerms == EValidity.Valid &&
                checkboxValidationStatus.value.authorizeSCR ==
                    EValidity.Valid &&
                checkboxValidationStatus.value.existsPEP == EValidity.Valid
            )
                return true
            else return false
        }
        const signContract = async () => {
            if (!validFrontSign(contractData.value)) return
            try {
                await c4bApi.contract().put(contractData.value)
                wasContractSigned.value = true
                messageResponse.value = {}
            } catch (err: any) {
                wasContractSigned.value = false
                messageResponse.value = err.response.data.errors
            }
        }
        const handleSuccessModalClose = () => {
            window.location.href = '/'
        }
        onBeforeMount(async () => {
            await getCustomerInfo()
            await generateContract()
            await getBankInfo()
            pageReady.value = true
        })
        return {
            pdfString,
            credit,
            installments,
            bank,
            branch,
            account,
            currencyFormatBR,
            contractData,
            signContract,
            wasContractSigned,
            handleSuccessModalClose,
            pageReady,
            messageResponse,
            ContractConfiguration,
            checkErrorsReturn,
            checkboxValidationStatus,
            EValidity,
            capitalize
        }
    },
})
